import React, { useContext } from "react";
import { Container, Col, Image, Row } from "react-bootstrap";
import { NavLink,useLocation } from "react-router-dom";
import MunicipalityDataContext from "../helpers/MunicipalityDataContext";

function Footer() {
  const { pathname } = useLocation();
  const municipalitiyData = useContext(MunicipalityDataContext); 
    // Conditionally set background image based on route
    const backgroundImage = (pathname === "/login" || pathname === "/") ? `url(${municipalitiyData?.backgroundImg})` : '';


  return (
    <div>
      <footer>
        <div
          style={{backgroundImage : backgroundImage}}
          className={pathname == "/login" || pathname == "/"  ? "rgc-footer" : "rgc-footer-inline"}
         >

             </div>
        <div className={pathname == "/login" || pathname == "/"  ? "rgc-footer-opacity" : ""}></div>
         {/* {pathname == "/" ?
             <div id="footers">
             <div
               id="Rgc-Footer-Mobile"
               className="rgc-mobile-footer d-block d-lg-none"
             >
               <Row className="justify-content-center rgc-mobile-content p-3">
                 <Col>
                   <NavLink to="/">
                     <i class="fas fa-home"></i>
                     <span>صفحه اصلی</span>
                   </NavLink>
                 </Col>
   
                 <Col>
                   <NavLink to="/profile">
                     <i class="fas fa-user"></i>
                     <span>پروفایل</span>
                   </NavLink>
                 </Col>
    
                 <Col>
                   <NavLink to="/ads">
                     <i class="fa fa-bullhorn"></i>
                     <span>تبلیغات شهری</span>
                   </NavLink>
                 </Col>
               </Row>
             </div>
           </div>
           :
           ""
      } */}
   
      </footer>
    </div>
  );
}

export default Footer;
